<template>
  <v-dialog v-model="isModalOpen" max-width="600" scrollable persistent>
    <v-card>
      <v-card-title> {{ cardTitle }} </v-card-title>
      <v-card-text style="max-height: 300px">
        <v-data-table :headers="headers" :items="localEans" :items-per-page="100" hide-default-footer>
          <template v-slot:item="{ item, index }">
            <tr class="eans-table">
              <td>
                <div class="d-flex align-center justify-center">
                  <input :id="`item-${index}`" v-model="item.isMain" type="radio" name="selected_item" :value="true" @change="removeIsMain(index)" />
                </div>
              </td>
              <td>
                <v-text-field
                  v-model="item.ean"
                  class="hidden-arrows"
                  outlined
                  type="number"
                  hide-details
                  dense
                  :error="$v.localEans.$each[index].ean.$error"
                  @keydown="$event.key === '-' ? $event.preventDefault() : null"
                />
              </td>
              <td>
                <v-text-field
                  v-model="item.packingQuantity.quantityPackaging"
                  class="hidden-arrows"
                  dense
                  outlined
                  type="number"
                  hide-details
                  :error="$v.localEans.$each[index].packingQuantity.quantityPackaging.$error"
                  @keydown="$event.key === '-' ? $event.preventDefault() : null"
                />
              </td>
              <td>
                <mf-button type="icon" icon="delete" color="cinza-l20" @click="deleteEan(index)" />
              </td>
            </tr>
          </template>
        </v-data-table>
        <div class="d-flex justify-center">
          <mf-button text color="marca-0-l40" class="mt-2" icon="add" label="Adicionar novo EAN" @click="addEans" />
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <mf-button class="mr-2" text label="Cancelar" @click="cancel" />
        <mf-button label="Salvar" @click="confirm" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { required, minLength, maxLength } from 'vuelidate/lib/validators'

export default {
  name: 'ProductEansTable',
  props: {
    value: {
      type: Object,
      required: true,
    },
    openDialog: {
      type: Boolean,
      required: true,
    },
  },
  data: () => ({
    cardTitle: '',
    localEans: [],
    newEan: {
      ean: '',
      isMain: false,
      packingQuantity: {
        quantityPackaging: '',
        name: '1',
      },
    },
  }),
  computed: {
    productForms: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    isModalOpen: {
      get() {
        return this.openDialog
      },
      set(value) {
        this.$emit('update:openDialog', value)
      },
    },
    headers() {
      return [
        {
          text: 'Principal',
          align: 'start',
          sortable: false,
          value: 'isMain',
        },
        { text: 'Ean', value: 'ean', width: '35%', align: 'left', sortable: false },
        { text: 'Quant. no pacote', value: 'packingQuantity.quantityPackaging', width: '35%', align: 'left', sortable: false },
        { text: 'Excluir', value: 'id', width: '20%', sortable: false },
      ]
    },
  },
  watch: {
    isModalOpen(value) {
      if (value) {
        this.setLocalEans()
      }
    },
  },
  methods: {
    setLocalEans() {
      const eans = structuredClone(this.productForms.eans)
      this.localEans = this.localEans.concat(...eans)

      this.setCardTitle()
    },
    setCardTitle() {
      this.cardTitle = this.localEans.length ? 'Editar EANs' : 'Criar EANs'
    },
    cancel() {
      this.isModalOpen = false
      this.localEans = []
    },
    confirm() {
      this.$v.$touch()

      if (this.$v.localEans.$error) {
        const hasRepeated = Object.entries(this.$v.localEans.$each.$iter).some((ean) => {
          return !ean[1].ean.isRepeated
        })

        if (hasRepeated) {
          this.$snackbar({ message: 'Existem EANs duplicados no seu produto.', snackbarColor: 'error' })

          return
        }

        if (this.$v.localEans.$each) this.$snackbar({ message: 'Preencha todos os eans corretamente', snackbarColor: 'error' })
        return
      }

      if (!this.localEans.some((ean) => ean.isMain)) {
        this.localEans[0].isMain = true
      }

      this.productForms.eans = this.localEans

      this.isModalOpen = false
      this.localEans = []
    },
    addEans() {
      this.localEans.push(structuredClone(this.newEan))
    },
    deleteEan(index) {
      this.localEans.splice(index, 1)
    },
    removeIsMain(number) {
      this.localEans.forEach((variation, index) => {
        if (index !== number) {
          variation.isMain = false
        }
      })
    },
  },
  validations() {
    return {
      localEans: {
        required,
        minLength: minLength(1),
        $each: {
          ean: {
            required,
            isRepeated: function (value) {
              return this.localEans.filter((ean) => ean.ean === value).length === 1
            },
            notOnlyZero: function (value) {
              return !/^0+$/.test(value)
            },
            notSpecialCaracter: function (value) {
              return !/-/.test(value)
            },
          },
          packingQuantity: {
            quantityPackaging: {
              packageValidation: function (value) {
                if ((!value || !value.length) && value !== 0) return true
                return parseInt(value) > 0
              },
              maxLength: maxLength(11),
            },
          },
        },
      },
    }
  },
}
</script>

<style lang="scss">
.eans-table {
  .v-text-field--outlined > .v-input__control > .v-input__slot {
    min-height: 40px;
  }
  input[type='radio'] {
    height: 15px;
    width: 15px;
  }
  input[type='radio']:hover {
    cursor: pointer;
  }
}
.hidden-arrows {
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none !important;
    margin: 0 !important;
  }
  input[type='number'] {
    -moz-appearance: textfield !important;
  }
}
</style>
